export const productHelper = {
  methods: {
    collectCharacteristicOptionsForSavingSort: function () {
      const options = {};
      this.availableOptions.forEach((option) => {
        const optionKey = `${option.name.toLowerCase()}s`,
          // eslint-disable-next-line no-underscore-dangle
          optionList = this._data[optionKey].map((item) => {
            return item.option;
          });
        if (optionList.length) {
          options[option.name.toLowerCase()] = optionList;
        }
      });
      return options;
    },
  },
};
